import React, { useEffect, useState } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { apiRequest } from '../../utils/api'
import '../../styles/admin/InquiryBox.css'
import { useAuthStore } from '../../store'
import SaveButton from '../common/SaveButton'
import { Icon } from '../../assets/icons'
import Alert from '../common/Alert'

const BoardDetailBox = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [post, setPost] = useState(null)
  const [comments, setComments] = useState([])
  const [newComment, setNewComment] = useState('')
  const [isEditing, setIsEditing] = useState(false)
  const [editedTitle, setEditedTitle] = useState('')
  const [editedContent, setEditedContent] = useState('')
  const { user } = useAuthStore()

  const userId = user.ID
  const userRole = user.STATUS

  const [showAlert, setShowAlert] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: () => {},
  })

  useEffect(() => {
    fetchDetail()
    fetchComments()
  }, [])

  const fetchDetail = async () => {
    const res = await apiRequest('/board/detail', 'POST', { id })
    setPost(res.data)
  }

  const handleEdit = () => {
    setEditedTitle(post.TITLE)
    setEditedContent(post.CONTENT)
    setIsEditing(true)
  }

  const saveEdit = async () => {
    await apiRequest('/board/update', 'POST', {
      id,
      title: editedTitle,
      content: editedContent,
    })
    setIsEditing(false)
    fetchDetail() // 수정 후 새로고침
  }

  const fetchComments = async () => {
    const res = await apiRequest('/board/comments', 'POST', { postId: id })
    setComments(res.data || [])
  }

  const submitComment = async () => {
    if (!newComment.trim()) return
    await apiRequest('/board/comments/insert', 'POST', {
      postId: id,
      authorId: userId,
      content: newComment,
    })
    setNewComment('')
    fetchComments()
  }

  const handleDeleteComment = (commentId) => {
    setShowAlert({
      isOpen: true,
      title: 'Delete Comment',
      message: 'Are you sure you want to delete this comment?',
      onConfirm: () => deleteComment(commentId),
    })
  }

  const deleteComment = async (commentId) => {
    await apiRequest('/board/comments/delete', 'POST', { id: commentId })
    fetchComments()
  }

  return (
    <div className="board-detail">
      <div className="board-header-buttons">
        <SaveButton onClick={() => navigate(-1)}>Back to List</SaveButton>

        {post && (
          <>
            {(userId === post.SENDER_ID || userRole === 'A') && !isEditing && (
              <SaveButton onClick={handleEdit}>Edit Post</SaveButton>
            )}
            {(userId === post.SENDER_ID || userRole === 'A') && isEditing && (
              <SaveButton onClick={saveEdit}>Submit</SaveButton>
            )}
          </>
        )}
      </div>

      {post && (
        <table className="inquiry-table2">
          <colgroup>
            <col width="15%" />
            <col width="35%" />
            <col width="15%" />
            <col width="35%" />
          </colgroup>
          <tbody>
            <tr>
              <th>Title</th>
              <td>
                {isEditing ? (
                  <input
                    value={editedTitle}
                    onChange={(e) => setEditedTitle(e.target.value)}
                    style={{ width: '100%' }}
                  />
                ) : (
                  post.TITLE
                )}
              </td>
              <th>Customer Type</th>
              <td>{post.ROLE}</td>
            </tr>
            <tr>
              <th>Date Created</th>
              <td>{post.REG_DTM}</td>
              <th>Author</th>
              <td>{post.SENDER_ID}</td>
            </tr>
            <tr>
              <th>Content</th>
              <td colSpan={3} className="content-cell">
                {isEditing ? (
                  <textarea
                    value={editedContent}
                    onChange={(e) => setEditedContent(e.target.value)}
                    rows={10}
                    style={{ width: '100%', padding: '10px' }}
                  />
                ) : (
                  post.CONTENT
                )}
              </td>
            </tr>
          </tbody>
        </table>
      )}

      <div className="comments">
        {comments.length === 0 && (
          <p className="no-comments">No comments yet.</p>
        )}
        {comments.map((c) => (
          <div key={c.ID} className="comment-item">
            <span className="comment-author">{c.AUTHOR_NAME}</span>
            <span className="comment-content">{c.COMMENT}</span>
            {(c.COMMENTER_ID === userId || userRole === 'A') && (
              <Icon
                name="trash"
                size={20}
                onClick={() => handleDeleteComment(c.ID)}
                color={'#b6bfca'}
                className="comment-delete-icon"
              />
            )}
          </div>
        ))}
        <div className="comment-form">
          <textarea
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Enter your comment"
            className="comment-textarea"
          />
          <div className="comment-submit-button">
            <SaveButton onClick={submitComment}>Write a Comment</SaveButton>
          </div>
        </div>
      </div>

      <Alert
        isOpen={showAlert.isOpen}
        onClose={() => setShowAlert((prev) => ({ ...prev, isOpen: false }))}
        title={showAlert.title}
        message={showAlert.message}
        confirmText="delete"
        cancelText="Cancel"
        onConfirm={showAlert.onConfirm}
        confirmColor="#e74c3c"
        showCancel={true}
      />
    </div>
  )
}

export default BoardDetailBox
